import React from 'react';

export interface VersionBadgeProps {
  version?: number;
}

/** "v2" badge shown when a clinical record has been reopened at least once */
const VersionBadge: React.FC<VersionBadgeProps> = ({ version }) => {
  if (!version || version <= 1) return null;
  return (
    <span
      className="px-2 py-0.5 rounded text-xs font-semibold bg-slate-100 text-slate-700 border border-slate-200"
      title={`Version ${version}`}
    >
      v{version}
    </span>
  );
};

export default VersionBadge;
